module.exports = __webpack_public_path__ + "static/media/mono_data_architecture.c02faae7.png";